import angular from "angular";

angular
    .module('app')
    .component('registerRequestForm', {
        controller: ['$http', 'Upload', controller],
        template: require('./register-request-form.html')
    });

function controller($http, Upload) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.getBanks();
    };

    $ctrl.getBanks = () => {
        $http.get('/data/get-banks').then(res => { $ctrl.banks = res.data; });
    };

    $ctrl.fullName = '';
    $ctrl.phone = '';
    $ctrl.email = '';
    $ctrl.organizationName = '';
    $ctrl.iin = '';
    $ctrl.organizationType = 'Физическое лицо';
    $ctrl.iban = '';
    $ctrl.bank = null;
    $ctrl.address = '';
    $ctrl.selectedFiles = [];

    $ctrl.file = null;

    $ctrl.canSubmit = false;

    $ctrl.fileSelected = () => {
        $ctrl.selectedFiles.push({
            file: $ctrl.file,
            name: $ctrl.file.name,
        });

        $ctrl.file = null;

        $ctrl.checkCanSubmit();
    };

    $ctrl.delSelectedFile = (ind) => {
        $ctrl.selectedFiles.splice(ind, 1);
        $ctrl.checkCanSubmit();
    };

    $ctrl.checkCanSubmit = () => {
        $ctrl.canSubmit =
            $ctrl.fullName &&
            $ctrl.phone &&
            $ctrl.email &&
            $ctrl.organizationName &&
            $ctrl.iin &&
            $ctrl.organizationType &&
            $ctrl.iban &&
            $ctrl.bank &&
            $ctrl.address &&
            $ctrl.selectedFiles &&
            $ctrl.selectedFiles.length
    }

    $ctrl.submit = () => {
        $ctrl.loading = false;
        $ctrl.status = null;

        Upload.upload({
            url: `/manual/register-request`,
            data: {
                full_name: $ctrl.fullName,
                phone: '7' + $ctrl.phone,
                email: $ctrl.email,
                organization_name: $ctrl.organizationName,
                iin: $ctrl.iin,
                type: $ctrl.organizationType,
                iban: $ctrl.iban,
                bank_title: $ctrl.bank.title,
                bank_bic: $ctrl.bank.bic,
                address: $ctrl.address,
                registration_files: $ctrl.selectedFiles.map(v => v.file),
            }
        }).then(
            res => {
                $ctrl.status = 'success';
                $ctrl.loading = false;
            },
            err => {
                $ctrl.status = 'error';
                $ctrl.loading = false;
            }
        );
    };


}


// WEBPACK FOOTER //
// ./resources/assets/manual/components/register-request-form/register-request-form.js